import { Grid, Tooltip, Typography } from '@mui/material'
import React, { memo } from 'react'
import { NavLink } from 'react-router-dom'

type Props = {
    label?: string
    path?: string
    drawerOpen?: boolean
    icon?: React.ReactNode
    onClick?: () => void
    style?: React.CSSProperties
}

const NavlinkWithTooltip = ({ label, path, drawerOpen, icon, onClick, style }: Props) => {
    return (
        <Tooltip
            placement="right"
            title={drawerOpen ? "" : <Typography variant="body1">{label}</Typography>}

        >
            <div className="nav-item" style={{ ...style }}>
                <NavLink to={path || "/profile"} onClick={onClick} >
                    <Grid
                        container
                        justifyContent={"space-between"}
                        alignItems={"center"}
                    >
                        <Grid item>
                            {icon}
                            <span
                                className="nav-label"
                                style={{
                                    display: "inline-block",
                                    maxWidth: drawerOpen ? 200 : 0,
                                    opacity: drawerOpen ? 1 : 0,
                                    transition:
                                        "max-width 0.3s cubic-bezier(0.4,0,0.2,1), opacity 0.2s, margin-left 0.3s",
                                    overflow: "hidden",
                                    whiteSpace: "nowrap",
                                    verticalAlign: "middle",
                                }}
                            >
                                {label || "Profile"}
                            </span>
                        </Grid>
                    </Grid>
                </NavLink>
            </div>
        </Tooltip>
    )
}

export default memo(NavlinkWithTooltip)
